var indexOf = [].indexOf;

import {
  colorPickerColors
} from 'constants/colors';

angular.module('gym.contacts').controller('EditFlagCtrl', ["$scope", "$rootScope", "$q", "$timeout", "$modalInstance", "EditEventService", "Restangular", "contact", "flag", function($scope, $rootScope, $q, $timeout, $modalInstance, EditEventService, Restangular, contact, flag) {
  var save;
  $scope.flag = flag;
  $scope.flag.rootObjectName = 'contact_flag';
  $scope.colors = colorPickerColors;
  $scope.allTags = Restangular.one('gyms', $rootScope.gym.id).all('tags').all('flags_all').getList().$object;
  $scope.tags = [].concat(flag.tag_list);
  if (flag.color) {
    flag.customColor = flag.color;
  }
  $scope.setColor = function(color) {
    $scope.flag.color = color;
    return $scope.flag.customColor = void 0;
  };
  $scope.isCustomColorSelected = function() {
    var ref;
    return $scope.flag.color && (ref = $scope.flag.color, indexOf.call($scope.colors, ref) < 0);
  };
  $scope.$on('colorpicker-closed', function(currentScope, color) {
    return $timeout(function() {
      return $scope.flag.color = color.value;
    });
  });
  $scope.loadTags = function(query) {
    var deferred;
    deferred = $q.defer();
    $timeout(function() {
      var result;
      result = $scope.allTags.filter(function(item) {
        return item.indexOf(query) > -1;
      });
      return deferred.resolve(result);
    });
    return deferred.promise;
  };
  $scope.close = function() {
    return $scope.notesSectionCtrl.isCreating = false;
  };
  $scope.addTag = function(tag) {
    flag.tag_list || (flag.tag_list = []);
    return flag.tag_list.push(tag.text);
  };
  $scope.removeTag = function(tag) {
    return flag.tag_list = _.without(flag.tag_list, tag.text);
  };
  save = function() {
    if (flag.id) {
      return flag.save();
    } else {
      return contact.all('flags').post($scope.flag);
    }
  };
  $scope.submit = function() {
    $scope.isLoading = true;
    $scope.flag.errors = void 0;
    return save().then(function() {
      return $modalInstance.close($scope.params);
    }, function(response) {
      $scope.isLoading = false;
      return $scope.flag.errors = response.data.errors;
    });
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
